import {Autocomplete, Box, createFilterOptions, TextField} from "@mui/material";
import React from "react";
import {MultiSearchProps} from "../../components/SearchBox";
import {Tables} from "../../apitypes";
import {useGetProfileQuery} from "./users_api";
import AvatarImage from "../storage/AvatarImage";


export default ({onChange, value}: MultiSearchProps<Tables<"profile">>) => {

    const {data} = useGetProfileQuery({});

    return <Autocomplete
        id={"OperationApiGet"}
        multiple
        options={data || []}
        autoHighlight
        sx={{minWidth: "200px"}}
        value={value}
        onChange={(e, v: Tables<"profile">[]) => onChange(v)}
        getOptionLabel={(option: Tables<"profile">) => {
            return option.fullName;
        }}
        filterOptions={createFilterOptions({
            stringify: (option) => option.fullName + " " + option.email,
        })}
        renderOption={(props, option: Tables<"profile">) => {
            return <Box component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...props}>
                <AvatarImage image_url={option.avatarUrl} bucket={"avatars"}/>  {option.fullName}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}

                label="Uporabnik"
                variant={"standard"}

            />
        )}
    />

}
